import React from 'react';
import PropTypes from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import { ReactComponent as IconWarning } from '../../../../assets/images/ic-warning.svg';
import './ModalErrorServicio.scss';

/**
 * Modal para mostrar error cuando no existe CSV
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal
 * @returns {React.ReactElement} - Componente ModalErrorServicio
 */
const ModalErrorServicio = ({ show, onClose }) => (
  <AUIModal
    autoHeight
    size="sm"
    show={show}
    actionButtons={[
      {
        value: 'tertiary',
        mode: 'tertiary',
        label: 'Volver',
        onClick: onClose,
        disabled: false,
      },
    ]}
    onClose={onClose}
  >
    <div className="modal-content">
      <IconWarning />
      <p>
        <b>
          No existe ninguna copia autorizada electrónica vinculada al código CSV que has introducido. Por favor,
          revisa el código e inténtalo de nuevo.
        </b>
      </p>
      <br />
      <p>Si sigues teniendo problemas puedes ponerte en contacto con el servicio de soporte.</p>
    </div>
  </AUIModal>
);

ModalErrorServicio.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalErrorServicio;
